import type { IRadioButton } from '@/components/RadioButtonController/RadioButton/RadioButton.types'

export const useWorkedWithBs = () => {
  const { t } = useI18n()
  const workedWithBs = ref<IRadioButton[]>([
    {
      id: 'worked-with-bs-0',
      label: t('form.no'),
      value: false,
    },
    {
      id: 'worked-with-bs-1',
      label: t('form.yes'),
      value: true,
    },
  ])

  return {
    workedWithBs,
  }
}

